import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NBulkOrder } from './bulk-order.interfaces';

@Injectable({
    providedIn: 'root'
})
export class BulkOrderResolver implements Resolve<any> {
    constructor(private iCmsBlockResource: ICmsBlockResource) {}
    resolve() {
        return Promise.all([this.iCmsBlockResource.retrieve({ bareUrl: NBulkOrder.BULK_BLOCK_URL }, undefined)]);
    }
}
